<template>
    <v-container class="toggle animated" fluid>
        <v-row dense>
            <v-col cols="12">
                <v-tabs
                    v-model="tab"
                    color="darkGreen"
                    @update:model-value="init()"
                    >
                    <v-tab value="department" :class="{'font-weight-black': tab == 'department'}">{{ $store.state.user.program?.abbrev }} Faculty</v-tab>
                    <v-tab value="requested" :class="{'font-weight-black': tab == 'requested'}">Faculty in other programs</v-tab>
                </v-tabs>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    density="comfortable"
                    solo
                    hide-details
                    rounded="lg"
                    color="primary"
                ></v-text-field>
            </v-col>
            <v-col class="text-right" cols="12" md="8">
                <v-btn
                v-if="tab == 'department'"
                @click="showAddDialog()"
                prepend-icon="mdi-plus"
                class="mt-1 rounded-lg"
                color="routesColor"
                height="40px"
                elevation="2">
                    Add Faculty Course Load
                </v-btn>
                <v-btn
                v-if="tab == 'requested'"
                @click="showAddRequestDialog()"
                prepend-icon="mdi-plus"
                class="mt-1 rounded-lg"
                color="routesColor"
                height="40px"
                elevation="2">
                    Request Faculty Course Load
                </v-btn>
            </v-col>
            <v-col cols="12">
                <v-row dense>
                    <v-col cols="12">
                        <v-card class="dt-container mt-2">    
                            <v-data-table
                                :mobile="isMobileOrTablet()"
                                :headers="headers"
                                :items="data"
                                :search="search"
                                :loading="loading"
                                :items-per-page="15"
                                :items-per-page-options="[15,30, 50, 100, -1]"
                                :custom-filter="customSearch"
                            >
                            <template v-slot:loading>
                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                            </template>
                            <template v-slot:item.name="{ item }">
                                <span>{{ item.fname }} {{ item.mname ? item.mname[0] + '.' : '' }} {{ item.lname }}{{ item.suffix ? ', ' + item.suffix : '' }}</span>
                            </template>
                            <template v-slot:item.datecreated="{ item }">
                                <span>{{ formatDateTime(item.datecreated)}} </span>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                <div class="d-flex justify-end ga-2">
                                    <v-btn v-if="tab == 'department'" @click="showEditDialog(item)" size="small" variant="outlined" text="View" color="green" elevation="3"></v-btn>
                                    <v-btn v-if="tab == 'requested'" @click="showEditRequestDialog(item)" size="small" variant="outlined" text="View" color="green" elevation="3"></v-btn>
                                </div>
                            </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>

    <v-dialog v-model="confirmDelete" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want delete this course?</div>
                <div class="font-weight-light mt-2">Note: Once confirmed, The action cannot be reversible.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmDelete = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="deleteCourse()" color="red" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <FacultyCourseLoadDialog ref="FacultyCourseLoadDialog" @refresh="init()"/>
    <RequestFacultyCourseLoadDialog ref="RequestFacultyCourseLoadDialog" @refresh="init()"/>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import FacultyCourseLoadDialog from '../Dialogs/FacultyCourseLoadDialog.vue';
import { useSnackbar } from '@/composables/useSnackbar'
import RequestFacultyCourseLoadDialog from '../Dialogs/RequestFacultyCourseLoadDialog.vue';

export default defineComponent({
    components: {
        FacultyCourseLoadDialog,
        RequestFacultyCourseLoadDialog
    },
    data(){
        return {
            data: [],
            search: null,
            loading: false,
            headers: [
                { title: 'Faculty Name', align: 'start', sortable: true, key: 'name' },
                { title: 'Program', align: 'start', sortable: true, key: 'program.abbrev' },
                { title: 'Academic Rank', align: 'start', sortable: true, key: 'academicRank.description' },
                { title: 'Employment Status', align: 'start', sortable: true, key: 'employmentStatus.description' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],

            confirmDelete: false,
            itemToDelete: null,
            loadingConfirmation: false,
            itemToActivate: null,
            tab: 'department',
        }
    },
    methods: {
        init(){
            this.loading = true
            const token = localStorage.getItem('aums-token')

            if(this.tab == 'department'){
                 axios.get(process.env.VUE_APP_SERVER_URL + '/user-details/findFacultyWithLoadByProgram/' + this.$store.state.user.program.id + '/' + this.$store.state.semester_schoolyear.id,
                { headers:
                    { 
                        'Authorization': `Bearer ${token}`,
                    }
                }
                ).then((res)=>{
                    if(res.data){
                        this.loading = false
                        this.data = res.data
                    }
                }).catch((error)=>{
                    if(error.response.status == 401){
                        this.loading = false

                        localStorage.removeItem("vuex");
                        localStorage.removeItem("aums-token");
                        window.location.reload();
                    }
                    else{
                        console.log(error)
                    }
                });
            }
            else if(this.tab == 'requested'){
                axios.get(process.env.VUE_APP_SERVER_URL + '/user-details/findRequestedFacultyWithLoadByOtherProgram/' + this.$store.state.user.program.id + '/' + this.$store.state.semester_schoolyear.id + '/' + this.$store.state.user.id,
                { headers:
                    { 
                        'Authorization': `Bearer ${token}`,
                    }
                }
                ).then((res)=>{
                    if(res.data){
                        this.loading = false
                        this.data = res.data
                    }
                }).catch((error)=>{
                    if(error.response.status == 401){
                        this.loading = false

                        localStorage.removeItem("vuex");
                        localStorage.removeItem("aums-token");
                        window.location.reload();
                    }
                    else{
                        console.log(error)
                    }
                });
            }
        },
        deleteCourse(){
            const { showSnackbar } = useSnackbar()
            this.loading = true
            const token = localStorage.getItem('aums-token')
            axios.delete(process.env.VUE_APP_SERVER_URL + '/faculty-load/' + this.itemToDelete.id ,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data.status == 200){
                    this.loading = false
                    showSnackbar('Faculty Load successfully deleted!')
                    this.confirmDelete = false
                    this.init()
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        showAddDialog(){
            this.$refs.FacultyCourseLoadDialog.initAdd()
        },
        showAddRequestDialog(){
            this.$refs.RequestFacultyCourseLoadDialog.initAdd()
        },
        showEditDialog(data){
            this.$refs.FacultyCourseLoadDialog.initUpdate(data)
        },
        showEditRequestDialog(data){
            this.$refs.RequestFacultyCourseLoadDialog.initUpdate(data)
        },
        showDeleteDialog(data){
            this.itemToDelete = data
            this.confirmDelete = true
        },
        customSearch(value, search, item) {
            if (!search) return true;

            const fullName = `${item.fname ?? ''} ${item.mname ?? ''} ${item.lname ?? ''} ${item.suffix ?? ''}`.toLowerCase();
            const safeSearch = search?.toLowerCase() ?? '';

            return (
            fullName.includes(safeSearch) ||
            JSON.stringify(item).toLowerCase().includes(safeSearch)
            );
        },
    },
    mounted(){
        this.init()
    }
})
</script>

<style scoped>

</style>